var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          !_vm.esEdicion
                            ? _vm.closeModal(false)
                            : (_vm.dialogConfirmacionClose = true)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.esEdicion
                          ? "Editar Tipo de Vehículo"
                          : "Ver Detalle Tipo de Vehículo"
                      )
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled:
                                  !_vm.validForm || _vm.btnBloquear
                                    ? true
                                    : false
                              },
                              on: {
                                click: function($event) {
                                  return _vm.grabarEdicion()
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                [
                  _c(
                    "v-card",
                    { attrs: { height: "55px", flat: "" } },
                    [
                      _c(
                        "v-bottom-nav",
                        {
                          attrs: {
                            active: _vm.bottomNav,
                            value: true,
                            absolute: "",
                            color: "transparent"
                          },
                          on: {
                            "update:active": function($event) {
                              _vm.bottomNav = $event
                            }
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.informacionGeneral.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.informacionGeneralVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (informacionGeneral.visible && esEdicion) ||\n                  (informacionGeneralVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.informacionGeneral.step
                              }
                            },
                            [
                              _c("span", [_vm._v("Información General")]),
                              _c("v-icon", [_vm._v("info")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.informacionGeneral.step &&
                            ((_vm.informacionGeneral.visible &&
                              _vm.esEdicion) ||
                              (_vm.informacionGeneralVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == informacionGeneral.step &&\n              ((informacionGeneral.visible && esEdicion) ||\n                (informacionGeneralVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "col-md-12",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.validForm,
                                    callback: function($$v) {
                                      _vm.validForm = $$v
                                    },
                                    expression: "validForm"
                                  }
                                },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass: "h2_title",
                                                  staticStyle: {
                                                    "margin-top":
                                                      "12px!important"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Información General\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-divider"),
                                      _c("br"),
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Código",
                                                  counter: 80,
                                                  type: "text",
                                                  disabled: true
                                                },
                                                model: {
                                                  value: _vm.editedItem.id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "id",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "editedItem.id"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|tipoVehiculoNombreUnicoEditar|max:80",
                                                    expression:
                                                      "\n                          'required|tipoVehiculoNombreUnicoEditar|max:80'\n                        "
                                                  }
                                                ],
                                                attrs: {
                                                  "error-messages": _vm.errors.collect(
                                                    "nombre"
                                                  ),
                                                  "data-vv-name": "nombre",
                                                  label: "Nombre",
                                                  type: "text",
                                                  counter: 80,
                                                  disabled: !_vm.esEdicion,
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.nombre,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "nombre",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.nombre"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required|max:200",
                                                    expression:
                                                      "'required|max:200'"
                                                  }
                                                ],
                                                attrs: {
                                                  "error-messages": _vm.errors.collect(
                                                    "descripcion"
                                                  ),
                                                  "data-vv-name": "descripcion",
                                                  label: "Descripción",
                                                  type: "text",
                                                  counter: 200,
                                                  disabled: !_vm.esEdicion
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.descripcion,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "descripcion",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.descripcion"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  items: _vm.estado,
                                                  label: "Estado",
                                                  "item-text": "nombre",
                                                  "item-value": "id",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "estado"
                                                  ),
                                                  "data-vv-name": "estado",
                                                  required: "",
                                                  "no-data-text":
                                                    "Sin resultados",
                                                  hint: _vm.mensajeCambioEstado,
                                                  "persistent-hint": ""
                                                },
                                                on: {
                                                  change: _vm.seleccionarEstado
                                                },
                                                model: {
                                                  value: _vm.editedItem.estado,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "estado",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.estado"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Tipo de Vehículo",
            nombreEntidad: _vm.tipoVehiculo.nombre
          }),
          mensaje: _vm.$t("mensajes.crud.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogCambioEstado,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Tipo de Vehículo",
            nombreEntidad: _vm.tipoVehiculo.nombre
          }),
          mensaje:
            _vm.$t("mensajes.crud.inactivo.mensaje") +
            " " +
            _vm.$t("mensajes.crud.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackEstado($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }